import { Injectable } from '@angular/core';
import { ActionsAdapter, PayrollDateResponse, ProgramInfo } from '@ppl/ui';
import { SharedDataService } from '../services/shared-data-service';
import { ListService } from '../services/list.service';
import { LookupService } from '../../services/lookup.service';
import { NotificationService } from '../services/notification.service';
import { ErrorAlertService } from '../services/error-alert.service';
import { UserService } from '../../services/user.service';
import { FileTriageService } from '../../services/fileTriage.service';
import { FileUploadNotificationService } from '../../services/file-upload-notification.service';
import { ClaimsService } from '../../services/claims.service';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class NextgenActionsAdapter implements ActionsAdapter {
  constructor(
    private sharedData: SharedDataService,
    private listService: ListService,
    private lookupService: LookupService,
    private notifySvc: NotificationService,
    private errorAlert: ErrorAlertService,
    private userSvc: UserService,
    private fileTriageSvc: FileTriageService,
    private fileUploadNotificationSvc: FileUploadNotificationService,
    private claimsSvc: ClaimsService
  ) {}

  getFlowType(sourcePage: string): string {
    return this.sharedData.getType(sourcePage);
  }

  getSelectedProgram(): ProgramInfo | null | undefined {
    const p: any = this.userSvc.getSelectedProgram();
    if (!p) return null;
    const program: ProgramInfo = {
      program_code: p.program_code,
      program_name: p.program_name ?? p.programCodeName ?? '',
      program_state: p.program_state ?? p.state ?? ''
    };
    return program;
  }

  getUserDetails() {
    return this.userSvc.getUserDetails();
  }

  fetchAssignableUsers(payload: Record<string, any>) {
    return this.listService.getUsers(payload);
  }

  assignUsers(payload: any) {
    return this.listService.assignUser(payload);
  }

  fetchPrograms(flow: string) {
    return this.listService.getPrograms() as unknown as Observable<ProgramInfo[]>;
  }

  getLookupValues(key: string) {
    return this.lookupService.getLookupValue(key);
  }

  updateUserStatus(payload: any, flow: string) {
    return this.listService.updateUserStatus(payload, flow);
  }

  updateParticipantStatus(payload: any) {
    return this.listService.updateParticipantStatus(payload, true);
  }

  sendNotification(from: string, payload: any) {
    return this.listService.sendNotification(from, payload);
  }

  sendRegistrationLink(payload: any, flow: string) {
    return this.listService.sendRegistrationLink(payload, flow);
  }

  acknowledgeFiles(rows: any[], programCode?: string) {
    return this.fileUploadNotificationSvc.acknowledgeFiles(rows as any, programCode as string);
  }

  openFileTriageDialog(rows: any[]): void {
    this.fileTriageSvc.callOpenDialogFunction(rows);
  }

  fetchPayrollCheckDates(): Observable<PayrollDateResponse> {
    return this.claimsSvc.getCheckDates();
  }

  submitPayrollProcessing(payload: any) {
    return this.claimsSvc.submitPayrollProcessing(payload);
  }

  updateAuthStatus(programCode: string | undefined, payload: any) {
    return this.claimsSvc.updateAuthStatus(programCode, payload);
  }

  notify(type: string, title: string, message: string): void {
    this.notifySvc.alert(type, title, message);
  }

  openErrorModal(title: string, message: string): void {
    this.errorAlert.openModal('error', title, message);
  }
}
